// SLIDERS
function sliders() {
  const swiper = new Swiper(".js-swiper", {
    spaceBetween: 5,
    slidesPerView: 5.5,
    freeMode: true,
    allowTouchMove: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 5,
        spaceBetween: 8,
        freeMode: false,
        allowTouchMove: false,
      }
    }
  });

  const swiper2 = new Swiper(".js-swiper2", {
    spaceBetween: 0,
    allowTouchMove: true,
    zoom: {
      maxRatio: 5,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper
    },
    breakpoints: {
      768: {
        allowTouchMove: false
      }
    }
  });

  $('.swiper-main .swiper-slide').each(function() {
    var item = $(this);
    item.on('mouseover', function() {
      var item1 = $(this);
      setTimeout(function() {
        if(item1.hasClass('swiper-slide-active')) {
          item.find('.swiper-zoom-container').addClass('test');
          swiper2.zoom.in();
        }
      }, 300);
    });

    item.on('mouseout', function() {
      setTimeout(function() {
        swiper2.zoom.out();
      }, 300);
    });
  })

  var clickImages = $('.option--color .clickyboxes li a'); 
  clickImages.each(function() {
    if($(this).data('image') !== "") {
      $(this).click(function(e) {
        var clickImage = $(this).data('image').trim();
        $('.swiper-main .swiper-slide').each(function(count) {
          if($(this).find('img').attr('src').indexOf(clickImage) > -1) {
            swiper2.slideTo(count);
          }
        })
      })
    }
  })
}

window.addEventListener('DOMContentLoaded', () => {
  sliders();
})